import { Container, styled } from "@mui/material";

export const ContainerContainer = styled(Container)(({ theme }) => ({
    maxWidth: "97vw",
    [theme.breakpoints.down("md")]: {
        maxWidth: "100%"
    }
}));

export default ContainerContainer